// MOTORE GLOBALE DELLA WISHLIST E CARRELLO
window.toggleProductWishlistItem = window.toggleProductWishlistItem || function(handle, title, price, image, btnElement) {
  let wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
  const index = wishlist.findIndex(item => item.handle === handle);

  if (index > -1) {
    wishlist.splice(index, 1);
    btnElement.classList.remove('is-active');
  } else {
    wishlist.push({ handle, title, price, image });
    btnElement.classList.add('is-active');
    if (navigator.vibrate) navigator.vibrate(50);
  }

  localStorage.setItem('koji_wishlist_data', JSON.stringify(wishlist));

  const headerBadges = document.querySelectorAll('.koji-wishlist-badge');
  headerBadges.forEach(badge => {
    badge.textContent = wishlist.length;
    badge.classList.toggle('is-active', wishlist.length > 0);
  });
};

document.addEventListener('DOMContentLoaded', function() {
  
  let observer;

  // ==========================================
  // 1. POP-UP VERIFICA ETÀ 16+
  // ==========================================
  const agePopup = document.getElementById('koji-age-popup');
  if (agePopup) {
    const isVerified = sessionStorage.getItem('koji_age_verified');
    if (!isVerified) { document.body.style.overflow = 'hidden'; } 
    else { agePopup.classList.remove('is-active'); document.body.style.overflow = ''; }

    const confirmBtn = document.getElementById('koji-age-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => {
        sessionStorage.setItem('koji_age_verified', 'true');
        agePopup.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    }
  }

  // ==========================================
  // 2. ORDINAMENTO NATURALE CACHATO (Zero Micro-Scatti)
  // ==========================================
  function sortCardsSmarter() {
    const grid = document.getElementById('koji-collection-grid');
    if (!grid) return;
    
    const cards = Array.from(grid.querySelectorAll('.koji-card-wrapper'));
    
    function parseMangaTitle(title) {
      const matches = title.match(/\b\d+\b/g);
      let vol = 0;
      let baseSeries = title;
      if (matches) {
        vol = parseInt(matches[matches.length - 1], 10);
        baseSeries = title.replace(/\s*(?:vol\.|volume|n\.|n|#)?\s*\b\d+\b[^\w]*$/i, '').trim();
      }
      return { baseSeries, vol };
    }

    // MAPPA CACHE: Evita di interrogare il DOM (getAttribute) durante il sort per non bloccare lo scroll
    const mappedCards = cards.map(card => {
      const title = (card.getAttribute('data-product-title') || "").toLowerCase();
      return { element: card, data: parseMangaTitle(title) };
    });

    mappedCards.sort((a, b) => {
      const cmp = a.data.baseSeries.localeCompare(b.data.baseSeries);
      if (cmp !== 0) return cmp;
      return a.data.vol - b.data.vol;
    });
    
    // DOCUMENT FRAGMENT: Aggiorna la griglia in un solo frame eliminando i ricalcoli del layout
    const fragment = document.createDocumentFragment();
    mappedCards.forEach(item => fragment.appendChild(item.element));
    grid.appendChild(fragment);
  }

  // ==========================================
  // 3. GESTIONE FILTRI PILLOLE E DOPPIA RICERCA
  // ==========================================
  const filterPills = document.querySelectorAll('.koji-filter-pill');
  const volumeSearchWrap = document.getElementById('koji-volume-search-wrapper');
  const volumeInput = document.getElementById('koji-volume-input');
  
  const titleSearchWrap = document.getElementById('koji-title-search-wrapper');
  const titleInput = document.getElementById('koji-title-input');
  
  let activePillFilter = null;

  function applyFilters() {
    const cards = document.querySelectorAll('.koji-card-wrapper');
    const pagination = document.getElementById('koji-pagination');
    let visibleCount = 0;
    
    const searchedVol = volumeInput ? volumeInput.value.trim() : "";
    const searchedTitle = titleInput ? titleInput.value.trim().toLowerCase() : "";

    cards.forEach(card => {
      const typeData = card.getAttribute('data-product-type') || "";
      const tagsData = card.getAttribute('data-product-tags') || "";
      const titleData = card.getAttribute('data-product-title') || "";
      const vendorData = card.getAttribute('data-product-vendor') || "";
      
      const allText = `${typeData} ${tagsData} ${titleData} ${vendorData}`.toLowerCase();
      let textWithoutJPop = allText.replace(/j-pop/g, ''); 

      // Pillola
      let matchesPill = false;
      if (!activePillFilter) {
        matchesPill = true;
      } else if (activePillFilter === 'manga') {
        if (typeData.includes('manga') || typeData.includes('pubblicazioni') || allText.includes('manga') || allText.includes('pubblicazioni') || allText.includes('fumett') || allText.includes('volume') || allText.includes('star comics') || allText.includes('planet') || allText.includes('j-pop') || allText.includes('panini') || allText.includes('edizioni')) matchesPill = true;
      } else if (activePillFilter === 'pop') {
        if (textWithoutJPop.includes('funko') || textWithoutJPop.includes('pop') || textWithoutJPop.includes('vinyl')) matchesPill = true;
      } else if (activePillFilter === 'figure') {
        if (allText.includes('figure') || allText.includes('statua') || allText.includes('banpresto') || allText.includes('bandai') || allText.includes('kotobukiya') || allText.includes('action figure')) matchesPill = true;
      } else if (activePillFilter === 'gadget') {
        if (typeData.includes('gadget') || allText.includes('gadget')) matchesPill = true;
      }

      // Volume
      let matchesVolume = true;
      if (searchedVol !== "") {
        const isManga = allText.includes('manga') || allText.includes('fumett') || allText.includes('volume') || typeData.includes('manga');
        const regexExactNumber = new RegExp(`\\b${searchedVol}\\b`, 'i');
        const hasNumber = regexExactNumber.test(titleData) || regexExactNumber.test(tagsData);
        if (!isManga || !hasNumber) matchesVolume = false;
      }

      // Titolo (Elastico)
      let matchesTitle = true;
      if (searchedTitle !== "") {
        const searchTerms = searchedTitle.split(/\s+/);
        for (let i = 0; i < searchTerms.length; i++) {
          const term = searchTerms[i];
          if (!titleData.includes(term) && !tagsData.includes(term) && !vendorData.toLowerCase().includes(term)) {
            matchesTitle = false;
            break;
          }
        }
      }

      // Risultato Finale
      if (matchesPill && matchesVolume && matchesTitle) {
        card.style.display = 'block';
        setTimeout(() => card.classList.add('is-visible'), 50); 
        visibleCount++;
      } else {
        card.style.display = 'none';
        card.classList.remove('is-visible');
      }
    });

    const grid = document.getElementById('koji-collection-grid');
    let emptyMsg = document.getElementById('koji-filter-empty');
    
    if (visibleCount === 0 && grid) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      if (pagination && !pagination.querySelector('.koji-sync-msg')) pagination.style.display = 'none';
    } else {
      if (emptyMsg) emptyMsg.style.display = 'none';
      if (pagination) pagination.style.display = 'flex';
    }
  }

  // Listener Pillole
  filterPills.forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('is-active')) {
        this.classList.remove('is-active');
        activePillFilter = null;
      } else {
        filterPills.forEach(f => f.classList.remove('is-active'));
        this.classList.add('is-active');
        activePillFilter = this.getAttribute('data-filter');
      }
      
      if (volumeSearchWrap) {
        if (activePillFilter === 'pop' || activePillFilter === 'figure' || activePillFilter === 'gadget') {
          volumeSearchWrap.style.display = 'none';
          volumeInput.value = ''; 
        } else {
          volumeSearchWrap.style.display = 'block';
        }
      }
      applyFilters();
    });
  });

  if (volumeInput) volumeInput.addEventListener('input', applyFilters);
  if (titleInput) titleInput.addEventListener('input', applyFilters);

  // ==========================================
  // 4. OBSERVER ANIMAZIONI A CASCATA
  // ==========================================
  observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target); 
      }
    });
  }, { root: null, rootMargin: '0px 0px -30px 0px', threshold: 0.1 });

  function observeCards() {
    const cardWrappers = document.querySelectorAll('.koji-card-wrapper:not(.is-visible)');
    cardWrappers.forEach(wrap => observer.observe(wrap));
  }

  // ==========================================
  // 5. SINCRONIZZAZIONE GLOBALE IN BACKGROUND
  // ==========================================
  async function fetchAllPages() {
    const grid = document.getElementById('koji-collection-grid');
    if (!grid) return;
    
    // FIX: Inizializziamo i prodotti già presenti sulla prima pagina per far funzionare i bottoni
    initProductCards();
    
    const totalPages = parseInt(grid.getAttribute('data-total-pages') || "1", 10);
    const currentPage = parseInt(grid.getAttribute('data-current-page') || "1", 10);
    const baseUrl = grid.getAttribute('data-url').split('?')[0];
    
    if (totalPages > 1) {
      const paginationWrap = document.getElementById('koji-pagination');
      if (paginationWrap) {
        paginationWrap.style.display = 'flex';
        paginationWrap.innerHTML = '<div class="koji-sync-msg"><svg viewBox="0 0 24 24" class="koji-spin-icon" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg><span>Sincronizzazione Radar in corso...</span></div>';
      }

      for (let i = 1; i <= totalPages; i++) {
        if (i === currentPage) continue;
        try {
          const res = await fetch(`${baseUrl}?page=${i}`);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const newCards = doc.querySelectorAll('.koji-card-wrapper');
          
          // DOCUMENT FRAGMENT: Evita freeze visivi durante l'aggiunta delle card
          const fragment = document.createDocumentFragment();
          newCards.forEach(card => fragment.appendChild(card));
          grid.appendChild(fragment);
          
          initProductCards();
          
          // Esecuzione fluida nel frame grafico del dispositivo
          requestAnimationFrame(() => {
            sortCardsSmarter();
            applyFilters();
            observeCards();
          });
          
        } catch(e) { console.error("Koji Radar Sync interrotto:", e); }
      }
      
      if(paginationWrap) paginationWrap.remove();
    } else {
      sortCardsSmarter();
      applyFilters();
      observeCards();
    }
  }

  // ==========================================
  // 6. FUNZIONI CARRELLO AJAX E WISHLIST SULLE CARD
  // ==========================================
  function updateWishlistHearts() {
    const wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
    document.querySelectorAll('.koji-card-wishlist-btn').forEach(btn => {
      const handle = btn.dataset.handle;
      if(wishlist.some(item => item.handle === handle)) { btn.classList.add('is-active'); } 
      else { btn.classList.remove('is-active'); }
    });
  }

  function updateHeaderCartBadge() {
    fetch('/cart.js')
      .then(resp => resp.json())
      .then(cartData => {
        const headerBadge = document.getElementById('koji-cart-badge');
        if (headerBadge) {
          headerBadge.textContent = cartData.item_count;
          if (cartData.item_count > 0) { headerBadge.classList.add('is-active'); } 
          else { headerBadge.classList.remove('is-active'); }
        }
      });
  }

  function initProductCards() {
    updateWishlistHearts();
    const productCards = document.querySelectorAll('[data-koji-card]');

    productCards.forEach(card => {
      if (card.dataset.initialized) return; 
      card.dataset.initialized = "true";

      const addBtn = card.querySelector('.koji-js-add-btn');
      const btnText = card.querySelector('.koji-drawer-text');
      const variantId = card.getAttribute('data-variant-id');
      const qtyControls = card.querySelector('.koji-drawer-qty-controls');
      const maxQtyAttr = card.getAttribute('data-max-qty');
      const maxQty = maxQtyAttr ? parseInt(maxQtyAttr, 10) : 9999;
      
      if (!addBtn || !variantId || !qtyControls) return;

      const qtyNumDisplay = qtyControls.querySelector('.koji-d-qty-num');
      const btnMinus = qtyControls.querySelector('.koji-d-qty-minus');
      const btnPlus = qtyControls.querySelector('.koji-d-qty-plus');

      let currentQtyInCart = 0; 
      const originalBtnText = btnText.textContent; 
      let qtyDebounceTimer;

      const updatePlusBtnUI = () => {
        if (currentQtyInCart >= maxQty) { btnPlus.classList.add('is-disabled'); } 
        else { btnPlus.classList.remove('is-disabled'); }
      };

      const executeCartUpdate = (targetQuantity) => {
        const isRemovingCompletely = targetQuantity === 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'id': variantId, 'quantity': targetQuantity })
        }).then(response => response.json()).then(data => {
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          if (isRemovingCompletely) {
            card.classList.remove('is-qty-mode');
            btnText.textContent = originalBtnText; 
            updatePlusBtnUI();
          }
        });
      };

      const updateCartDebounced = (targetQuantity) => {
        clearTimeout(qtyDebounceTimer);
        qtyDebounceTimer = setTimeout(() => { executeCartUpdate(targetQuantity); }, 500);
      };

      addBtn.addEventListener('click', function(e) {
        if (e.target.closest('.koji-drawer-qty-controls')) return;
        if (card.classList.contains('is-qty-mode')) return;
        e.preventDefault(); e.stopPropagation(); 
        if (navigator.vibrate) navigator.vibrate(40);
        this.blur(); 
        this.classList.add('is-loading');
        currentQtyInCart = 1;
        updatePlusBtnUI();
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'items': [{ 'id': variantId, 'quantity': 1 }] })
        }).then(response => response.json()).then(data => {
          this.classList.remove('is-loading');
          card.classList.add('is-success');
          btnText.textContent = 'PRESO!';
          if (qtyNumDisplay) qtyNumDisplay.textContent = currentQtyInCart;
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          setTimeout(() => {
            card.classList.remove('is-success');
            card.classList.add('is-qty-mode');
          }, 1000); 
        });
      });

      if (btnPlus && btnMinus) {
        btnPlus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (currentQtyInCart >= maxQty) { if (navigator.vibrate) navigator.vibrate([20, 50, 20]); return; }
          if (navigator.vibrate) navigator.vibrate(20);
          currentQtyInCart++;
          qtyNumDisplay.textContent = currentQtyInCart;
          updatePlusBtnUI();
          updateCartDebounced(currentQtyInCart); 
        });

        btnMinus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (navigator.vibrate) navigator.vibrate(20);
          if (currentQtyInCart > 0) {
            currentQtyInCart--;
            if (currentQtyInCart > 0) { qtyNumDisplay.textContent = currentQtyInCart; } 
            else { qtyNumDisplay.textContent = "0"; }
            updatePlusBtnUI();
            updateCartDebounced(currentQtyInCart);
          }
        });
      }
    });
  }

  // Lanciamo la Sincronizzazione Subito
  fetchAllPages();

  // ==========================================
  // 7. SCORRIMENTO FLUIDO VERSO LA CHAT DEL COVO
  // ==========================================
  const scrollToChatBtn = document.getElementById('koji-scroll-to-chat');
  if (scrollToChatBtn) {
    scrollToChatBtn.addEventListener('click', function(e) {
      const targetSection = document.getElementById('koji-comments-section');
      if (targetSection) {
        e.preventDefault();
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

});